import { useCallback } from 'react';
import { IBuiltCar } from '../../../../../common/model/IBuiltCar';
import thunkActions from '../../store/actions/thunkActions';
import { carConfigurationActions } from '../../store/reducers/carConfigurationReducer';
import { AppDispatch } from '../../../common/store';
import { useDispatch } from 'react-redux';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import useGetPostCode from '../../../common/react/useGetPostCode';
import useWidgetContext from '../../../common/react/useWidgetContext';
import useCustomerStorage from '../../../common/hooks/useCustomerStorage';

const useConfigureActions: () => {
  selectStockCar: (car: IBuiltCar) => void;
  configureBasket: (car: IBuiltCar) => void;
} = () => {
  const dispatch: AppDispatch = useDispatch();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const postcode = useGetPostCode();
  const {
    configuration: { dimensions },
  } = useWidgetContext();
  const { customerStorage } = useCustomerStorage();

  const configureBasket = useCallback(
    async (car: IBuiltCar) => {
      const dealerId = customerStorage.getCustomerData()?.dealerId || null;
      const { payload } = (await dispatch(
        thunkActions.initBasket({
          initRequest: {
            vehicleId: car.carId,
            vehicleAccessories: car.accessories || [],
            vehicleAccessoryPacks: car.packs || [],
            vehicleServicePlan: car.servicePlan || null,
            dealerId,
            postcode,
            configurationSourceUrl: window.location.toString(),
          },
          priceDisplay,
          dimensions,
        }),
      )) as any;
      if (payload) {
        dispatch(carConfigurationActions.setDataFromDeal(payload.deal));
      }
    },
    [postcode],
  );

  const selectStockCar = useCallback(
    async (car: IBuiltCar) => {
      const dealerId = customerStorage.getCustomerData()?.dealerId || null;
      const { payload } = (await dispatch(
        thunkActions.selectStockCar({
          stockRequest: {
            vehicleId: car.carId,
            vehicleAccessories: car.accessories || [],
            vehicleAccessoryPacks: car.packs || [],
            vehicleServicePlan: car.servicePlan || null,
            dealerId,
            postcode,
            configurationSourceUrl: window.location.toString(),
          },
          priceDisplay,
        }),
      )) as any;
      if (payload) {
        dispatch(carConfigurationActions.setDataFromDeal(payload.deal));
      }
    },
    [postcode],
  );

  return { selectStockCar, configureBasket };
};

export default useConfigureActions;
